import { Component, OnInit, ViewChild } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CompanyApiService } from 'src/app/services/api/companies.api.service';
import { countries } from '../../../assets/data/countries';
import { Role } from 'src/app/classes/Role.class';
import { getRoles } from '../../../assets/data/roles';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Company } from 'src/app/classes/Company.class';
import { User } from 'src/app/classes/User.class';
import { Language } from 'src/app/classes/Language.class';
import { getAllLanguages } from 'src/assets/data/languages';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'user-choose-company-screen',
  templateUrl: './user-choose-company.screen.html',
  styleUrls: ['./user-choose-company.screen.scss'],
})
export class UserChooseCompanyScreenComponent implements OnInit {
  @ViewChild(NgSelectComponent) cityNgSelectComponent: NgSelectComponent;

  @ViewChild(NgSelectComponent) companyNgSelectComponent: NgSelectComponent;

  user: any;
  countries: any[] = [];
  companies: { data: Company[] };
  selectableCompanies: Company[] = [];
  cities: Array<string> = [];
  country: string;
  city: string;
  id: string;
  roles: Role[];
  showPersonalDataForm = false;
  errorUser = false;
  userSaved = false;
  modalText = '';
  prefix = '';
  phone = '';
  userExists = false;
  languages: Language[];

  constructor(
    private userApiService: UserApiService,
    private router: Router,
    private _location: Location,
    private companyApiService: CompanyApiService,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    this.user = {
      language: 'en',
    };
    this.companies = await this.companyApiService.getActiveCompanies();
    this.companies.data.forEach(company => {
      if (!this.countries.includes(company.country)) {
        this.countries.push(company.country);
      }
    });
    countries.forEach(element => {
      if (this.countries.includes(element.code)) {
        this.countries.push({ name: element.name, code: element.code });
        this.countries.splice(this.countries.indexOf(element.code), 1);
      }
    });

    this.languages = getAllLanguages();
  }

  async next() {
    this.roles = await this.setSelectableUserRoles(this.user.companyId);
    this.showPersonalDataForm = true;
  }

  setUserRequestForCompanyName(e) {
    if (e.mowaId !== null) {
      this.user.requestForCompanyName = e.mowaId;
    }
  }

  filterCities(isInit = false) {
    this.city = null;
    this.companyNgSelectComponent.clearModel();
    if (!isInit) this.user.companyId = null;
    const companies = this.companies.data.filter(e => {
      return e.country == this.country;
    });
    const cities = [];
    for (let i = 0; i < companies.length; i++) {
      if (!cities.includes(companies[i].city)) cities.push(companies[i].city);
    }
    this.cities = cities;
  }

  filterCompanies(isInit = false) {
    if (!isInit) this.user.companyId = null;
    const companies = this.companies.data.filter(e => {
      if (e.country === this.country) {
        return e.city == this.city;
      }
    });
    this.selectableCompanies = companies;
  }

  async saveUser() {
    if (Object.keys(this.user).length > 0) {
      if (this.prefix.length > 1 && this.phone.length > 0) {
        this.user.phone = this.prefix + this.phone;
      }

      if (this.user.role === 'admin') {
        this.user.mustDoQuizes = true;
      }

      if (this.user.companyId && this.user.requestForCompanyName) {
        this.user.mustDoQuizes = true;
        const response = await this.userApiService.saveUser(this.user);
        if (response.code) {
          this.errorUser = true;
        } else {
          this.setModalText('response.save_user');
          this.userSaved = true;
          setTimeout(() => {
            this.userSaved = false;
            this.router.navigateByUrl('/users');
          }, 2700);
        }
      }
    }
  }

  async checkIfUserExists(user) {
    this.userExists = await this.userApiService.checkIfUserExists(user.email);
    if (!this.userExists) this.saveUser();
  }

  async deleteUser() {
    const response = await this.userApiService.deleteUser(this.user.id);
    if (response) this.router.navigateByUrl('/users');
  }

  goBack() {
    this._location.back();
  }

  closeModal() {
    this.userSaved = false;
  }

  setModalText(val: string) {
    this.modalText = val;
  }

  private async setSelectableUserRoles(companyId: number): Promise<Role[]> {
    const adminRole: string = await this.userApiService.getAdminRole();
    if (adminRole === 'mowa_admin') {
      const roles = [...getRoles(true, this.translate.getDefaultLang())];
      const check = await this.checkIfSuperAdminExists(companyId);
      if (check) roles.shift();
      return roles;
    } else {
      return getRoles(false, this.translate.getDefaultLang());
    }
  }

  /**
   * check if super admin is already set for selected OT
   */
  private async checkIfSuperAdminExists(companyId: number): Promise<boolean> {
    const companyUsers: User[] = await this.userApiService.getUsersForCompany(companyId);
    let check = false;
    companyUsers.forEach(user => {
      if (user.role === 'super_admin') check = true;
    });
    return check;
  }
}
